import { Phone } from '../../../shared/enums/Phone';

export const SUCCESS_MESSAGE = `Success! Your comment has been submitted and a member of our team will get back to you shortly. If you don't hear from us soon, you can call us directly at ${Phone.Contact}`;
